import { render } from "./scroll-pane.vue?vue&type=template&id=629d6c92&scoped=true"
import script from "./scroll-pane.vue?vue&type=script&lang=js"
export * from "./scroll-pane.vue?vue&type=script&lang=js"

import "./scroll-pane.vue?vue&type=style&index=0&id=629d6c92&lang=less&scoped=true"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629d6c92"]])

export default __exports__